import React, { useState } from "react";

import "./retrieve_email.css";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import LockResetIcon from "@mui/icons-material/LockReset";
import logo from "../../images/PPKM_Head.png";
import getEventController from "../Member/Controller/getEvent_controller";

const RetrieveEmail = () => {
  const navigate = useNavigate();
  const [membershipNo, setMembershipNo] = useState("");
  const [NRIC, setNRIC] = useState("");
  const [error, setError] = useState(null);

  const handleNRICChange = (e) => {
    const input = e.target.value;

    // Remove any non-numeric characters and dashes
    const numbersOnly = input.replace(/\D/g, "");

    // Insert dashes dynamically based on length
    let formattedNRIC = numbersOnly;

    if (numbersOnly.length > 6) {
      formattedNRIC = `${numbersOnly.slice(0, 6)}-${numbersOnly.slice(6)}`;
    }
    if (numbersOnly.length > 8) {
      formattedNRIC = `${numbersOnly.slice(0, 6)}-${numbersOnly.slice(
        6,
        8
      )}-${numbersOnly.slice(8)}`;
    }

    setNRIC(formattedNRIC);
  };

  const handleRetrieveEmail = async (e) => {
    e.preventDefault();
    setError(null); // Reset error

    const sanitizedNRIC = NRIC.replace(/-/g, "");

    console.log(membershipNo);
    console.log(sanitizedNRIC);

    // Call the authentication function
    const data = await getEventController.retrieveEmailbyIC(
      membershipNo,
      sanitizedNRIC
    );

    if (data) {
      // If successful, navigate to the next page, e.g., OTP page or dashboard
      alert(`Your account email is: ${data.email}`);
      navigate("/login");
      console.log(data.email);
    } else {
      setError("Invalid email. Please try again.");
    }
  };

  return (
    <div className="retrieve-email-page">
      <div className="d-flex retrieve-email-container">
        <div className="retrieve-email-wrapper">
          <div className="login-title">
            <img className="web-login-logo" src={logo} alt="Logo" />
          </div>
          <p className="title_para">RETRIEVE EMAIL</p>
          <p className="re-span">
            Enter your Membership No. and NRIC number to retrieve email address.
          </p>
          <form className="retrieve-email-form" onSubmit={handleRetrieveEmail}>
            <div className="fpf-row">
              <div className="mt-2">
                <label className="form-label re-form-label">
                  Membership No.
                </label>
                <input
                  type="text"
                  placeholder="Your Membership Number"
                  value={membershipNo}
                  onChange={(e) => setMembershipNo(e.target.value)}
                  required
                />
              </div>
              <div className="mt-2">
                <label className="form-label re-form-label">NRIC No.</label>
                <input
                  type="text"
                  placeholder="XXXXXX-XX-XXXX"
                  value={NRIC}
                  onChange={(e) => handleNRICChange(e)}
                  maxLength={14} // Ensures input does not exceed the format
                  required
                />
              </div>
            </div>
            <div>
              <Button className="reset-button" type="submit">
                Retrieve Email
              </Button>
            </div>
            <div>
              <Button
                className="reset-button"
                onClick={() => navigate("/login")}
              >
                Return to Login Page
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default RetrieveEmail;
